import store from '../store/index';

if(process.env.VUE_APP_DEVICE == 'desktop') {
  let url_locale = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');
  let locale = (url_locale.trim().length && url_locale != "/") ? url_locale : null;
  
  if(locale != null && store.getters['language/getLanguages'][locale]) {
      store.dispatch('language/setHasLangInUrl', true);
      store.dispatch('language/setLocale', locale);
  }
  else {
      store.dispatch('language/setHasLangInUrl', false);
      let url = window.location.origin + '/' + store.getters['language/getDefaultLanguage'] + window.location.pathname;
      window.location = url;
  }
}